import styled from "styled-components";
import React, {useContext, useState} from "react";
import Images from "../../assets/images/Images";
import {RegionSelectedContext, regionValues} from "../../contexts/RegionSelectedContext";
import ContentContainer from "../../components/contentWrapper/ContentWrapper";
import HomeContainer from "../home/HomeContainer";
import TotalRankingContainer from "../totalRanking/TotalRankingContainer";
import MarketAnalysisContainer from "../marketAnalysis/MarketAnalysisContainer";
import MarketClusteringContainer from "../marketClustering/MarketClusteringContainer";
import BranchRankingContainer from "../branchRanking/BranchRankingContainer";
import BranchAnalysisContainer from "../branchAnalysis/BranchAnalysisContainer";
import BranchClusteringContainer from "../branchClustering/BranchClusteringContainer";

const RImageContainer = styled.div`
    pointer-events: none;
    @media (min-width: 481px){
        position: fixed;
        bottom: ${(props: {fullImage: boolean}) => props.fullImage ? '-10px' : '-200px'};
        right: ${(props: {fullImage: boolean}) => props.fullImage ? '50px' : '-50px'}; ;
        transition: all 0.5s ease-out;
    }

    @media (max-width: 480px) {
        visibility: hidden;
        position: fixed;
        bottom: -10px;
        right: 50px
    }
`;

const CustomRImg = styled.img`
    opacity: 0.2;
    height: 500px;
    filter: brightness(0) saturate(100%) invert(17%) sepia(43%) saturate(4661%) hue-rotate(335deg) brightness(88%) contrast(125%);
`;

const RComponent: React.FC<{fullImage: boolean}> = ({fullImage}) => {
    return (
        <RImageContainer fullImage={fullImage}>
            <CustomRImg
                src={Images.r}
                alt="LogoR"
            />
        </RImageContainer>
    )
};

const MainContent: React.FC = () => {
    // @ts-ignore
    const {regionSelected} = useContext(RegionSelectedContext);

    const [tabSelected, setTabSelected] = useState<number>(1);

    const handleTabChange = (id: number) => {
        setTabSelected(id);
    };

    return (
        <>
            <ContentContainer
                handleClick={() => handleTabChange(1)}
                tabSelected={tabSelected}
                tabId={1}
            >
                <HomeContainer
                    isTabSelected={tabSelected === 1}
                />
            </ContentContainer>

            <ContentContainer
                handleClick={() => handleTabChange(2)}
                tabSelected={tabSelected} tabId={2}
            >
                <TotalRankingContainer isTabSelected={tabSelected === 2} />
            </ContentContainer>

            <ContentContainer
                handleClick={() => handleTabChange(3)}
                tabSelected={tabSelected}
                tabId={3}
            >
                {
                    regionSelected === regionValues.europe ?
                        <MarketAnalysisContainer isTabSelected={tabSelected === 3} /> :
                        <MarketClusteringContainer isTabSelected={tabSelected === 3} />
                }
            </ContentContainer>

            <ContentContainer
                handleClick={() => handleTabChange(4)}
                tabSelected={tabSelected}
                tabId={4}
            >
                <BranchRankingContainer isTabSelected={tabSelected === 4} />
            </ContentContainer>

            <ContentContainer
                handleClick={() => handleTabChange(5)}
                tabSelected={tabSelected}
                tabId={5}
            >
                {
                    regionSelected === regionValues.europe ?
                        <BranchAnalysisContainer isTabSelected={tabSelected === 5} /> :
                        <BranchClusteringContainer isTabSelected={tabSelected === 5} />
                }
            </ContentContainer>
        </>
    )
};

export default MainContent;
